/* ------------------------------------------------------------------
   Untitan - bundle 3 paliers

   Deux modes :
   - autonome  (data-standalone) : formulaire et bouton propres, envoi classique.
   - greffe    (par defaut)      : branche sur le formulaire produit natif.

   Pour un set de 2 ou 3 poeles, les tailles peuvent differer : le formulaire
   natif ne sait pas envoyer plusieurs variantes. On intercepte donc l envoi
   et on poste items[] en /cart/add.js.

   IMPORTANT : apres cet ajout, il faut redemander au theme de re-rendre son
   tiroir. Ce theme n ecoute pas d evenement DOM "cart:refresh" (il utilise
   son propre theme.pubsub), donc on passe par l API de rendu de sections :
   /cart/add.js accepte un parametre "sections" et renvoie le HTML a jour.
   Sans cela le tiroir restait fige sur son etat precedent, sans selecteur
   de quantite.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function drawer() {
    return document.getElementById('CartDrawer');
  }

  function sectionId() {
    var d = drawer();
    return d ? d.getAttribute('data-section-id') : null;
  }

  /* Remplace le contenu de la section tiroir par le HTML fraichement rendu */
  function swapSection(html) {
    var id = sectionId();
    if (!id || !html) return false;
    var host = document.getElementById('shopify-section-' + id);
    if (!host) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-' + id);
    if (!fresh) return false;
    host.innerHTML = fresh.innerHTML;
    return true;
  }

  function openDrawer() {
    var opener = document.querySelector('[aria-controls="CartDrawer"]');
    if (opener) {
      opener.click();
      return;
    }
    var d = drawer();
    if (d) {
      d.removeAttribute('hidden');
      d.setAttribute('open', 'true');
      d.setAttribute('active', 'true');
    }
  }

  function init(root) {
    if (!root || root.dataset.on) return;
    root.dataset.on = '1';

    var opts = root.querySelectorAll('.ktb__o');
    if (!opts.length) return;

    function selected() {
      var found = null;
      opts.forEach(function (x) {
        if (x.getAttribute('aria-checked') === 'true') found = x;
      });
      return found || opts[0];
    }

    function items() {
      var out = [];
      selected().querySelectorAll('[data-ktb-var]').forEach(function (s) {
        out.push({ id: parseInt(s.value, 10), quantity: 1 });
      });
      return out;
    }

    function target() {
      if (root.dataset.standalone) return root;
      var own = root.closest('form[action*="/cart/add"]');
      if (own && !own.hasAttribute('data-ktb')) return own;
      var all = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < all.length; i++) {
        if (!all[i].hasAttribute('data-ktb')) return all[i];
      }
      return null;
    }

    function syncQty() {
      var f = target();
      if (!f || f === root) return;
      var q = f.querySelector('input[name="quantity"]');
      if (q) q.value = selected().dataset.qty;
    }

    opts.forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (e.target.closest('.ktb__vars')) return;
        opts.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
        syncQty();
      });
    });

    /* Ajout au panier + re-rendu du tiroir */
    function addToCart(list) {
      var body = { items: list };
      var id = sectionId();
      if (id) {
        body.sections = id;
        body.sections_url = window.location.pathname;
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var swapped = false;
          if (data && data.sections && id) swapped = swapSection(data.sections[id]);
          if (drawer()) {
            openDrawer();
            // Si la section n a pas pu etre remplacee, on recharge plutot que
            // de laisser un tiroir incoherent.
            if (!swapped) window.location.reload();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () { window.location.href = '/cart'; });
    }

    if (root.dataset.standalone) {
      root.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(items());
      });
      return;
    }

    var f = target();
    if (!f || f.dataset.ktbHook) return;
    f.dataset.ktbHook = '1';
    syncQty();

    f.addEventListener(
      'submit',
      function (e) {
        var list = items();
        if (list.length < 2) return; // 1 seule poele : le theme gere
        e.preventDefault();
        e.stopImmediatePropagation();
        addToCart(list);
      },
      true
    );
  }

  function boot() {
    document.querySelectorAll('[data-ktb]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
